import * as React from 'react';

import _ from 'underscore';

import {ListSummaryStat} from './list-summary-stat';
import type {Summary} from './list-summary-stat';

import styles from './list-summary-bar.module.css';

type ListSummaryBarProps = {
    summaries: Partial<Record<any, Summary>>;
    stats: any;
    appliedStatuses: string[];
    isFirstLoad: boolean;
    isFiltering: boolean;
    isUnderlined?: boolean;
};

export class ListSummaryBar extends React.Component<ListSummaryBarProps> {
    shouldComponentUpdate(nextProps: ListSummaryBarProps) {
        // If our status filter changes, wait until we're done filtering to update
        // this component so we don't render different stat components with the wrong
        // subset of data
        if (nextProps.isFiltering) {
            return false;
        }

        return true;
    }

    render() {
        const {stats, isFirstLoad, appliedStatuses} = this.props;
        const shouldShowWinRate =
            !appliedStatuses.length ||
            (appliedStatuses.length > 1 && _.contains(appliedStatuses, 'Won'));

        return (
            <div
                className={
                    this.props.isUnderlined ? styles['container-underlined'] : styles.container
                }
            >
                {Object.keys(this.props.summaries).map((id) => {
                    const summary = this.props.summaries[id];

                    return (
                        <ListSummaryStat
                            // @ts-expect-error
                            key={summary.label}
                            isDisabled={id === 'winRate' && !shouldShowWinRate}
                            isLoading={isFirstLoad}
                            isUnderlined={this.props.isUnderlined}
                            // @ts-expect-error
                            data={stats[summary.key]}
                            // @ts-expect-error
                            summary={summary}
                        />
                    );
                })}
            </div>
        );
    }
}
